import * as api from '../api';

(() => {
    let phone;
    let phoneR;

    window.initPhoneInput = () => {
        const intput = document.querySelector("#phone");
        const intputR = document.querySelector("#phoneR");

        if (intput) {
            phone?.destroy?.();
            phone = window.intlTelInput(intput, {
                initialCountry: "fr",
                countryOrder: ['fr', 'gb', 'it', 'de', 'es', 'ch'],
                separateDialCode: true,
                autoPlaceholder: 'polite',
                loadUtils: () => import("../dependencies/intlTelInput-util.js"),
                //geoIpLookup: ,
            });
            intput.iti = phone;
        }

        if (intputR) {
            phoneR?.destroy?.();
            phoneR = window.intlTelInput(intputR, {
                initialCountry: "fr",
                countryOrder: ['fr', 'gb', 'it', 'de', 'es', 'ch'],
                separateDialCode: false,
                autoPlaceholder: 'polite',
                loadUtils: () => import("../dependencies/intlTelInput-util.js"),
                //geoIpLookup: ,
            });

            if (intputR.value) {
                phoneR.setNumber(intputR.value);
            }
            intputR.iti = phoneR;
        }

    };

    window.autoResizeTextarea = (textarea, short = false) => {
        if (textarea.scrollHeight >= 100 || short) {
            textarea.style.height = 'auto';
            textarea.style.height = textarea.scrollHeight + 'px';
        }
    };

    window.updateHelico = (helico, available, comments) => {
        api.updateHelicopter({...helico, available, comments})
            .then(() => M.toast({html: 'Modification sauvegardée', classes: 'green accent-4'}));
    };

    window.sendSms = (event) => {
        const msgData = {
            ...Object.fromEntries(new FormData(document.querySelector('#sms-form'))),
            to: phone.getNumber(),
            country: phone.getSelectedCountryData().dialCode,
            event
        };

        api.sendMessage(msgData);
    };
    window.sendSmsR = (event, message_type_id) => {
        let lang;
        if (phoneR.getSelectedCountryData().dialCode === "33") {
            lang = "FR";
        } else {
            lang = "EN";
        }
        const msgData = {
            ...Object.fromEntries(new FormData(document.querySelector('#sms-formR'))),
            to: phoneR.getNumber(),
            country: phoneR.getSelectedCountryData().dialCode,
            lang: lang,
            event
        };

        if (message_type_id) {
            msgData.message_type_id = message_type_id;
        }

        api.sendMessage(msgData);
    };

    window.onSmsTypeChange = (select, eventId) => {
        if (select.value) {
            window.sendSmsR(eventId, select.value);
            select.value = '';
        }
    };
})();